/** 列表标签与表单 tooltip：对外「连续支付」，说明联调用途和风险。 */
export const CONTINUOUS_PAY_TOOLTIP =
  '仅测试套餐开启。开启后小程序会循环拉起支付（联调循环），成功仍开通 VIP。';

export const CONTINUOUS_PAY_EXTRA = '不要对正式售卖套餐打开此开关。';

/** 创建/更新必须显式带 0 或 1；缺省、非法值一律按关闭，避免更新漏传关不掉。 */
export function toContinuousPayFlag(value: unknown): 0 | 1 {
  return value === 1 || value === true || value === '1' ? 1 : 0;
}
